import { useRecoilValue } from "recoil";
import classNames from "classnames";

import { mediaState, authState } from "@/comn/features/recoil";
import { Logo } from "./Logo";

import { HeaderMenu } from "./Header/HeaderMenu";
import { HeaderSignButton } from "./Header/HeaderSignButton";
import { HeaderEctiButton } from "./Header/HeaderEctiButton";
import { HeaderTodoButton } from "./Header/HeaderTodoButton";
import { HeaderThemeToggle } from "./Header/HeaderThemeToggle";
import { HeaderLanguageSelect } from "./Header/HeaderLanguageSelect";
import { HeaderResourceButton } from "./Header/HeaderResourceButton";
import { HeaderMenuToggle } from "./Header/HeaderMenuToggle";
import { HeaderIQSButton } from "./Header/HeaderIQSButton";
import { HeaderNotiButton } from "./Header/HeaderNotiButton";

import { Dev_HeaderTestButton } from "./Header/Dev_HeaderTestButton";
import { Dev_HeaderRouteToggle } from "./Header/Dev_HeaderRouteToggle";
import { HeaderSurvButton } from "./Header/HeaderSurvButton";

const Header = () => {
    const { lg } = useRecoilValue(mediaState);
    const { isSignedIn } = useRecoilValue(authState);

    return (
        <header
            className={classNames(
                "flex z-[50] px-4 justify-between",
                "sm:h-[120px] sm:flex-col sm:bg-white sm:relative dark:sm:bg-transparent",
                "md:h-[60px] md:bg-white md:relative dark:md:bg-transparent",
                "lg:h-[60px]",
            )}
        >
            {lg ? <HeaderMenu /> : <Logo />}

            <div className={classNames("flex items-center gap-2 justify-end h-[60px]", "md:mr-[36px]")}>
                {process.env.NODE_ENV === "development" && <Dev_HeaderRouteToggle />}

                {/* Sign */}
                {!lg && <HeaderSignButton />}

                {/* Ecti */}
                {(process.env.REACT_APP_BASE === "/ecti" || process.env.NODE_ENV === "development") && (
                    <HeaderEctiButton />
                )}

                {/* survey  */}
                {["tancis", "tanesw", "tanoga"].includes(process.env.REACT_APP_SYSTEM_GROUP || "") && (
                    <HeaderSurvButton />
                )}

                {/* Password Expiration Notification */}
                {["tancis", "tanesw", "tanoga"].includes(process.env.REACT_APP_SYSTEM_GROUP || "") && isSignedIn && (
                    <HeaderNotiButton />
                )}

                {/* IQS */}
                {["tancis"].includes(process.env.REACT_APP_SYSTEM_GROUP || "") && isSignedIn && <HeaderIQSButton />}

                {/* Todo */}
                {["tancis", "tanoga"].includes(process.env.REACT_APP_SYSTEM_GROUP || "") && isSignedIn && (
                    <HeaderTodoButton />
                )}

                {/* Test */}
                {process.env.NODE_ENV === "development" && <Dev_HeaderTestButton />}

                <HeaderThemeToggle />
                <HeaderLanguageSelect />
                <HeaderResourceButton />
            </div>

            {!lg && <HeaderMenuToggle />}
        </header>
    );
};

export default Header;
